import SVG from "react-inlinesvg";

// import React from 'react';
import ActivityDoneImg from "../../assets/Images/activity-done.png";
import CoachIcon from "../../assets/Images/coach.png";
import HoursIcon from "../../assets/Images/hours.png";
import NewCoachIcon from "../../assets/Images/newCoach.png";
import NewMemberIcon from "../../assets/Images/newMember.png";
import PaymentIcon from "../../assets/Images/payment.png";
import ScheduleIcon from "../../assets/Images/schedule.png";
import MemberIcon from "../../assets/Images/member.png";
import MinMemberIcon from "../../assets/Images/minMember.png";
import { faHeart } from "@fortawesome/free-solid-svg-icons";
// import calendarIcon from '../../assets/Images/calendarIcon.png';
import timeIcon from "../../assets/Images/time.png";
import userDummy from "../../assets/Images/dummy.jpg";
import userDummy1 from "../../assets/Images/userDummy1.png";
import Group from "../../assets/Images/group.png";
import GroupDisable from "../../assets/Images/group_disable.png";
import Info from "../../assets/Icon/info.svg";
import facebookIcon from "../../assets/Images/facebookIcon.svg";
import logoApple from "../../assets/Images/logoApple.svg";

import GymStudio from "../../assets/Images/sidebar_gym_studio.png";
import calorieIcon from "../../assets/Images/calorie.svg";
import calorieIconDisable from "../../assets/Images/calorie_Disable.svg";
import timerIcon from "../../assets/Images/timer.svg";
import verified from "../../assets/Images/icn_verified.svg";
import logo from "../../assets/Images/logo.png";
import userCover from "../../assets/Images/userCover.png";
import Bitmap from "../../assets/Images/Bitmap.png";
import DefaultImage from "../../assets/Images/Bitmap.svg";
import defaultClassInfo from "../../assets/Images/defaultClassInfo.png";
import check from "../../assets/Images/check.png";
import RequestUser from "../../assets/Images/request_user.png";
import RemoveUser from "../../assets/Images/removed_user.png";
import cardBackground from "../../assets/Images/cardBackground.png";
import americanExpress from "../../assets/Images/americanExpress.png";
import visaLogo from "../../assets/Images/visaLogo.png";
import diner from "../../assets/Images/diner.png";
import discover from "../../assets/Images/discover.png";
import jcb from "../../assets/Images/jcb.png";
import mastercard from "../../assets/Images/mastercard.png";
import union from "../../assets/Images/union.png";

// =================SIDEBAR ICONS========================
import Dashboard from "../../assets/Images/sidebar_dashboard.png";
import Schedule from "../../assets/Images/sidebar_schedule.png";
import Ongoing from "../../assets/Images/sidebar_onGoingActivity.png";
import Activity from "../../assets/Images/sidebar/my_activity.svg";
import Recorded from "../../assets/Images/sidebar/recordedActivity.svg";
import Messages from "../../assets/Images/sidebar/messages.svg";
import Coaches from "../../assets/Images/sidebar/coaches.svg";
// import Members from '../../assets/Images/sidebar/members.svg';
import Members from "../../assets/Images/sidebar_members.png";
import Payments from "../../assets/Images/sidebar/payments.svg";
import Setting from "../../assets/Images/sidebar/settings.svg";
import onDemandActivity from "../../assets/Images/sidebar/onDemand.svg";
import onDemandActivityWhite from "../../assets/Images/sidebar/onDemandWhite.svg";
import upcomingClass from "../../assets/Images/sidebar/upcoming_class.svg";
import videoLibrary from "../../assets/Images/sidebar/video_library.svg";
import integration from "../../assets/Images/sidebar/integration.svg";
import classSummary from "../../assets/Images/sidebar/class_summary.svg";
// =========================================================

// ====================HEADER  ICONS =======================
import StopIcon from "../../assets/Images/header_stop.png";
import addCardFooterImage from "../../assets/Images/addCardFooterImage.png";
// =========================================================

// ====================PROFILE DROPDOWN ICONS ==============
import accountDetails from "../../assets/Images/profileDropdown/icn_account_detail.svg";
import agreements from "../../assets/Images/profileDropdown/icn_agreements.svg";
import privacyPolicy from "../../assets/Images/profileDropdown/icn_privacy_policy.svg";
import streamPlaceholder from "../../assets/Images/Artboard.svg";
import streamPlaceholder1 from "../../assets/Images/Artboard-1.svg";
import helpCenter from "../../assets/Images/profileDropdown/helpCenter.svg";
// =========================================================

// ==================== ZYM PROFILE ==============
import zym from "../../assets/profile/zym.png";
import zym1 from "../../assets/profile/zym1.png";
// =========================================================

// ==================== SPECIALISIMS ==============
import Running from "../../assets/Images/Running.png";
import Dance from "../../assets/Images/Dance.png";
import Postnatal from "../../assets/Images/Postnatal.png";
import Strength from "../../assets/Images/Postnatal.png";
import Functional from "../../assets/Images/Functional.svg";
import Calisthenics from "../../assets/Images/Calisthenics.png";
import Sports from "../../assets/Images/Sports.png";
import Stretch from "../../assets/Images/Stretch.png";
// import Strength from '../../assets/Images/Strength.png';
import Prenatal from "../../assets/Images/Prenatal.png";
import Motivation from "../../assets/Images/Motivation.png";
import Pilates from "../../assets/Images/Pilates.png";
import Boxing from "../../assets/Images/Boxing.png";
import Spinning from "../../assets/Images/Spinning.png";
import Medication from "../../assets/Images/Medication.png";
import Bootcamp from "../../assets/Images/Bootcamp.png";
import Core from "../../assets/Images/Core.png";
import Barre from "../../assets/Images/Barre.png";
import Rowing from "../../assets/Images/Rowing.png";
import Martial from "../../assets/Images/Martial.png";
import Elliptical from "../../assets/Images/Elliptical.png";
import Yoga from "../../assets/Images/Yoga.png";
import checkImage from "../../assets/Images/checkImage.png";
import smallCalorie from "../../assets/Images/smallCalorie.png";
import copyIcon from "../../assets/Images/copyIcon.png";
import activityImage from "../../assets/Images/activityImage.jpg";
import noStreaming from "../../assets/Images/noStreaming.png";
// =========================================================

import blackImage from "../../assets/Images/black.png";
import membersLive from "../../assets/Images/membersLive.png";
import mindBodyLogo from "../../assets/Images/mindBodyLogo.png";
import marianaTek from "../../assets/Images/marianaTek.png";
import companyPH from "../../assets/Images/companyLogo.svg";
import activationPending from "../../assets/Images/activationPending.png";
import downArrow from "../../assets/Images/downArrow.svg";
import addMember from "../../assets/Images/addMember.svg";
import downloadIcon from "../../assets/Images/downloadIcon.svg";
import excelUpload from "../../assets/Images/excelUpload.svg";
import scheduleRoom from "../../assets/Images/scheduleRoom.svg";
import openRoom from "../../assets/Images/openRoom.svg";
import closedRoom from "../../assets/Images/closedRoom.svg";
import availableRoom from "../../assets/Images/availableRoom.svg";
import waitingRoom from "../../assets/Images/waitingRoom.svg";
import deepLink from "../../assets/Images/deepLink.svg";
import notValid from "../../assets/Images/NotValid.svg";
import validEmail from "../../assets/Images/validEmail.svg";
import passwordLock from "../../assets/Images/PaswordLock.svg";
import publicLock from "../../assets/Images/publicLock.svg";
import crossIcons from "../../assets/Images/crossIcon.svg";

import vod from "../../assets/Images/vod.svg";
import live from "../../assets/Images/live.svg";
import leftSection from "../../assets/Images/leftSection.png";

// Template Icon
import deletes from "../../assets/Template/delete.svg";
import copy from "../../assets/Template/copy.svg";
import share from "../../assets/Template/share.svg";
import shareActive from "../../assets/Template/shareActive.svg";
import shareDisable from "../../assets/Template/shareDisable.svg";
import edit from "../../assets/Template/edit.svg";

// Activity Type
import barre from "../../assets/activityType/barre.svg";
import bootcamp from "../../assets/activityType/bootcamp.svg";
import boxing from "../../assets/activityType/boxing.svg";
import cardio from "../../assets/activityType/cardio.png";
import celebrity from "../../assets/activityType/celebrity.svg";
import core from "../../assets/activityType/core.svg";
import cycling from "../../assets/activityType/cycling.svg";
import dance from "../../assets/activityType/dance.svg";
import hiit from "../../assets/activityType/hiit.svg";
import meditation from "../../assets/activityType/meditation.svg";
import mobility from "../../assets/activityType/mobility.svg";
import other from "../../assets/activityType/other.svg";
import pilates from "../../assets/activityType/pilates.svg";
import seniorFitness from "../../assets/activityType/seniorFitness.svg";
// import strength from '../../assets/activityType/seniorFitness.svg';
import sports from "../../assets/activityType/sports.svg";
import streching from "../../assets/activityType/streching.svg";
import toning from "../../assets/activityType/toning.svg";
import yoga from "../../assets/activityType/yoga.svg";

// Icon
import contactSupport from "../../assets/Icon/contactSupport.svg";
import dropdown from "../../assets/Icon/dropdown.svg";
import activeDown from "../../assets/Icon/activeDown.svg";
import down from "../../assets/Icon/down.svg";
import up from "../../assets/Icon/up.svg";
import activeUp from "../../assets/Icon/activeUp.svg";
import addTemplate from "../../assets/Icon/addTemplate.svg";
import search from "../../assets/Icon/search.svg";
import low from "../../assets/Icon/low.svg";
import medium from "../../assets/Icon/medium.svg";
import high from "../../assets/Icon/high.svg";
import back from "../../assets/Icon/back.svg";

// Difficulty
import beginner from "../../assets/Icon/difficultyBeginner.svg";
import intermediate from "../../assets/Icon/difficultyIntermediate.svg";
import advanced from "../../assets/Icon/difficultyAdvanced.svg";

import template from "../../assets/Icon/template.svg";

import offline from "../../assets/Images/noInternet.svg";

//import loginVideo from '../../assets/video/login.mp4';
import bellIcon from "../../assets/Icon/bellIcon.svg";
import windowIcon from "../../assets/Icon/windowIcon.svg";
import dumbell from "../../assets/Icon/dumbell.svg";
import calorie from "../../assets/Icon/calorie.svg";
import homeNav from "../../assets/Icon/homeNav1.svg";
import dumbellNav from "../../assets/Icon/dumbellNav.svg";
import manJumping from "../../assets/Icon/manJumping.svg";
import ondemandNav from "../../assets/Icon/ondemandNav.svg";
import liveUpcomingNav from "../../assets/Icon/liveUpcomingNav1.svg";
import mySchedule from "../../assets/Icon/mySchedule1.svg";
import clock from "../../assets/Icon/clock.svg";
import watch from "../../assets/Icon/watch.svg";
import watchHeartRate from "../../assets/Icon/watchHeartRate.svg";

// import crossIcon from '../../assets/Icon/crossIcon.svg';
import emailInput from "../../assets/Icon/emailInput.svg";
import passwordInput from "../../assets/Icon/passwordInput.svg";
import validTick from "../../assets/Icon/validTick.svg";
import logout from "../../assets/Icon/logout.svg";
import dropdownSetting from "../../assets/Icon/dropdownSetting.svg";
import dropdownProfile from "../../assets/Icon/dropdownProfile.svg";
import playIcon from "../../assets/Icon/playIcon.svg";
import cameraIcon from "../../assets/Icon/cameraIcon.svg";
import locationPin from "../../assets/Icon/locationPin.svg";
import carouselRightIcon from "../../assets/Icon/carouselRightIcon.svg";
import exercise1 from "../../assets/Images/exercise1.jpeg";
import exercise2 from "../../assets/Images/exercise2.jpeg";
import InternalBackground from "../../assets/Images/InternalBackground.png";

import seekBack from "../../assets/Images/seekBack.png";
import coachBackground from "../../assets/Images/coachBackground.svg";
import seekForward from "../../assets/Images/seekForward.png";
import videoPause from "../../assets/Images/videoPause.png";
import videoPlay from "../../assets/Images/videoPlay.png";
import calories_icon1 from "../../assets/Icon/calories_icon1.png";
import pinIcon from "../../assets/Icon/pin_icon.svg";
import audio from "../../assets/Icon/audio.svg";
import noaudio from "../../assets/Icon/noAudio.svg";
import video from "../../assets/Icon/video.svg";
import novideo from "../../assets/Icon/noVideo.svg";
import volume from "../../assets/Icon/volume.svg";
import novolume from "../../assets/Icon/novolume.svg";
import full_screen from "../../assets/Icon/full_screen.svg";
import exit_full_screen from "../../assets/Icon/exit_full_screen.svg";
import backgroundStats1 from "../../assets/Icon/statsBox_icon.svg";
import heartIcon from "../../assets/Icon/heart_icon.svg";
import rank_icon from "../../assets/Icon/rank_icon.svg";
import chatIcon1 from "../../assets/Icon/Chat.svg";
import memberIcon1 from "../../assets/Icon/member_icon.svg";
import arrowIcon from "../../assets/Icon/arrow_icon.svg";
import moreIcon from "../../assets/Icon/more_icon.svg";
import stopVideoIcon from "../../assets/Icon/stopVideo_icon.svg";
import crossIcon from "../../assets/Icon/cross_icon.svg";
import categoryBackground from "../../assets/Icon/categoryBackground.svg";
import newRibbon from "../../assets/Icon/newRibbon.svg";
import category from "../../assets/Icon/category.svg";
import leftArrow from "../../assets/Icon/leftArrow.svg";
import rightArrow from "../../assets/Icon/rightArrow.svg";
import video_icon from "../../assets/Icon/videoIcon.svg";
import cameraIcon1 from "../../assets/Icon/cameraIcon1.svg";
import playIcon1 from "../../assets/Icon/playIcon1.svg";
import HeartRateIcon from "../../assets/Icon/HeartRateIcon.svg";
import editBannerIcon from "../../assets/Icon/editBannerIcon.svg";
import editProfileImageIcon from "../../assets/Icon/editProfileImageIcon.svg";
import sendMessage from "../../assets/Images/sendMessage.svg";
import joinStudio from "../../assets/Images/forgotPassword.png";
import forgotPassword from "../../assets/Images/joinStudio.png";
import calendarIcon from "../../assets/Icon/calendarIcon.svg";
import femaleIcon from "../../assets/Icon/femaleIcon.svg";
import maleIcon from "../../assets/Icon/maleIcon.svg";
import otherGender from "../../assets/Icon/otherGender.svg";
import deleteAccount from "../../assets/Icon/deleteAccount.svg";
import swapIcon from "../../assets/Icon/swap_icon.svg";
import loadingSpinner from "../../assets/Icon/loadingSpinner.svg";

import T1 from "../../assets/Icon/trending/1.svg";
import T2 from "../../assets/Icon/trending/2.svg";
import T3 from "../../assets/Icon/trending/3.svg";
import T4 from "../../assets/Icon/trending/4.svg";
import T5 from "../../assets/Icon/trending/5.svg";
import T6 from "../../assets/Icon/trending/6.svg";
import T7 from "../../assets/Icon/trending/7.svg";
import T8 from "../../assets/Icon/trending/8.svg";
import T9 from "../../assets/Icon/trending/9.svg";
import T10 from "../../assets/Icon/trending/10.svg";
import T11 from "../../assets/Icon/trending/11.svg";
import T12 from "../../assets/Icon/trending/12.svg";
import T13 from "../../assets/Icon/trending/13.svg";
import T14 from "../../assets/Icon/trending/14.svg";
import T15 from "../../assets/Icon/trending/15.svg";
import T16 from "../../assets/Icon/trending/16.svg";
import T17 from "../../assets/Icon/trending/17.svg";
import T18 from "../../assets/Icon/trending/18.svg";
import T19 from "../../assets/Icon/trending/19.svg";
import T20 from "../../assets/Icon/trending/20.svg";

/* Zero State Icons */

import noLiveNow from "../../assets/Icon/zerostate_live_now.svg";
import noLiveUpcomingForDay from "../../assets/Icon/zerostate_live_upcomin_for_day.svg";

const selectIcon = (icon) => {
  switch (icon) {
    /* case 'loginVideo':
            return loginVideo; */

    case "T1":
      return T1;
    case "T2":
      return T2;
    case "T3":
      return T3;
    case "T4":
      return T4;
    case "T5":
      return T5;
    case "T6":
      return T6;
    case "T7":
      return T7;
    case "T8":
      return T8;
    case "T9":
      return T9;
    case "T10":
      return T10;
    case "T11":
      return T11;
    case "T12":
      return T12;
    case "T13":
      return T13;
    case "T14":
      return T14;
    case "T15":
      return T15;
    case "T16":
      return T16;
    case "T17":
      return T17;
    case "T18":
      return T18;
    case "T19":
      return T19;
    case "T20":
      return T20;
    //Zero State
    case "noLiveNow":
      return noLiveNow;
    case "noLiveUpcomingForDay":
      return noLiveUpcomingForDay;
    case "offline":
      return offline;
    case "template":
      return template;
    case "Running":
      return Running;
    case "stopVideoIcon":
      return stopVideoIcon;
    case "startVideoIcon":
      return playIcon;
    case "swapIcon":
      return swapIcon;
    case "seekBack":
      return seekBack;
    case "coachBackground":
      return coachBackground;
    case "category":
      return category;
    case "sendMessage":
      return sendMessage;
    case "forgotPassword":
      return forgotPassword;
    case "calendarIcon":
      return calendarIcon;
    case "joinStudio":
      return joinStudio;
    case "video_icon":
      return video_icon;
    case "leftArrow":
      return leftArrow;
    case "rightArrow":
      return rightArrow;
    case "loadingSpinner":
      return loadingSpinner;
    case "categoryBackground":
      return categoryBackground;
    case "newRibbon":
      return newRibbon;
    case "seekForward":
      return seekForward;
    case "videoPause":
      return videoPause;
    case "maleIcon":
      return maleIcon;
    case "femaleIcon":
      return femaleIcon;
    case "otherGender":
      return otherGender;
    case "deleteAccount":
      return deleteAccount;
    case "videoPlay":
      return videoPlay;
    case "pinIcon":
      return pinIcon;
    case "crossIcon":
      return crossIcon;
    case "rank_icon":
      return rank_icon;
    case "chatIcon1":
      return chatIcon1;
    case "memberIcon1":
      return memberIcon1;
    case "HeartRateIcon":
      return HeartRateIcon;
    case "calories_icon1":
      return calories_icon1;
    case "arrowIcon":
      return arrowIcon;
    case "editBannerIcon":
      return editBannerIcon;
    case "editProfileImageIcon":
      return editProfileImageIcon;
    case "audio":
      return audio;
    case "noaudio":
      return noaudio;
    case "video":
      return video;
    case "novideo":
      return novideo;
    case "heartIcon":
      return heartIcon;
    case "volume":
      return volume;
    case "novolume":
      return novolume;
    case "full_screen":
      return full_screen;
    case "exit_full_screen":
      return exit_full_screen;
    case "moreIcon":
      return moreIcon;
    case "backgroundStats1":
      return backgroundStats1;
    case "Dance":
      return Dance;
    case "Sports":
      return Postnatal;
    case "Spinning":
      return Sports;
    case "Outdoors":
      return Stretch;
    case "strength":
      return Strength;
    case "leftSection":
      return leftSection;
    case "functional":
      return Functional;
    case "calisthenics":
      return Calisthenics;
    case "Prenatal":
      return Prenatal;
    case "Motivation":
      return Motivation;
    case "Pilates":
      return Pilates;
    case "Boxing":
      return Boxing;
    case "Cycling":
      return Spinning;
    case "Medication":
    case "Meditation":
      return Medication;
    case "Bootcamp":
      return Bootcamp;
    case "Core":
      return Core;
    case "Barre":
      return Barre;
    case "Rowing":
      return Rowing;
    case "userCover":
      return userCover;
    case "Martial Arts":
      return Martial;
    case "Elliptical":
      return Elliptical;
    case "Yoga":
      return Yoga;
    case "info":
      return Info;
    case "zym":
      return zym;
    case "zym1":
      return zym1;
    case "requestUser":
      return RequestUser;
    case "removeUser":
      return RemoveUser;
    // case 'rejectUser':
    //     return rejectUser;
    case "check":
      return check;
    case "caloriesDisable":
      return calorieIconDisable;
    case "calories":
      return calorieIcon;
    case "DefaultImage":
      return DefaultImage;
    case "defaultClassInfo":
      return defaultClassInfo;
    case "heart":
      return faHeart;
    case "group":
      return Group;
    case "groupDisable":
      return GroupDisable;
    case "activity":
      return ActivityDoneImg;
    case "coach":
      return CoachIcon;
    case "newCoach":
      return NewCoachIcon;
    case "facebookIcon":
      return facebookIcon;
    case "appleIcon":
      return logoApple;
    case "newMember":
      return NewMemberIcon;
    case "payment":
      return PaymentIcon;
    case "hours":
      return HoursIcon;
    case "minMember":
      return MinMemberIcon;
    case "member":
      return MemberIcon;
    case "schedule":
      return ScheduleIcon;
    case "calender":
      return calendarIcon;
    case "time":
      return timeIcon;
    case "sidebar_dashboard":
      return Dashboard;
    case "sidebar_schedule":
      return Schedule;
    case "sidebar_ongoing":
      return Ongoing;
    case "sidebar_activity":
      return Activity;
    case "sidebar_recorded":
      return Recorded;
    case "Bitmap":
      return Bitmap;
    case "sidebar_messages":
      return Messages;
    case "sidebar_coaches":
      return Coaches;
    case "sidebar_members":
      return Members;
    case "sidebar_payment":
      return Payments;
    case "sidebar_setting":
      return Setting;
    case "sidebar_gym_studio":
      return GymStudio;
    case "playIcon":
      return playIcon;
    case "cameraIcon":
      return cameraIcon;
    case "playIcon1":
      return playIcon1;
    case "cameraIcon1":
      return cameraIcon1;
    case "header_stop":
      return StopIcon;
    case "timer":
      return faHeart;
    case "calorieIcon":
      return calorieIcon;
    case "timerIcon":
      return timerIcon;
    case "userDummy":
      return userDummy;
    case "userDummy1":
      return userDummy1;
    case "verified":
      return verified;
    case "logo":
    case "tribe":
      return logo;
    case "checkImage":
      return checkImage;
    case "agreements":
      return agreements;
    case "accountDetails":
      return accountDetails;
    case "helpCenter":
      return helpCenter;
    case "privacyPolicy":
      return privacyPolicy;
    case "streamPlaceholder":
      return streamPlaceholder;
    case "streamPlaceholder1":
      return streamPlaceholder1;
    case "black":
      return blackImage;
    case "membersLive":
      return membersLive;
    case "downArrow":
      return downArrow;
    case "scheduleRoom":
      return scheduleRoom;
    case "waitingRoom":
      return waitingRoom;
    case "closedRoom":
      return closedRoom;
    case "openRoom":
      return openRoom;
    case "availableRoom":
      return availableRoom;
    case "deepLink":
      return deepLink;
    case "onDemandActivityWhite":
      return onDemandActivityWhite;
    case "onDemandActivity":
      return onDemandActivity;
    case "smallCalorie":
      return smallCalorie;
    case "copyIcon":
      return copyIcon;
    case "mindbody":
      return mindBodyLogo;
    case "marianatek":
      return marianaTek;
    case "companyPH":
      return companyPH;
    case "activationPending":
      return activationPending;
    case "activityImage":
      return activityImage;
    case "addMember":
      return addMember;
    case "downloadIcon":
      return downloadIcon;
    case "excelUpload":
      return excelUpload;
    case "notValid":
      return notValid;
    case "validEmail":
      return validEmail;
    case "publicLock":
      return publicLock;
    case "passwordLock":
      return passwordLock;
    case "crossIcons":
      return crossIcons;
    // Side Navigation
    case "upcoming_class":
      return upcomingClass;
    case "class_summary":
      return classSummary;
    case "video_library":
      return videoLibrary;
    case "integration":
      return integration;
    case "vod":
      return vod;
    case "live":
      return live;

    // Template
    case "delete":
      return deletes;
    case "copy":
      return copy;
    case "share":
      return share;
    case "shareActive":
      return shareActive;
    case "shareDisable":
      return shareDisable;
    case "edit":
      return edit;

    // Activity Type
    case "barre":
      return barre;
    case "bootcamp":
      return bootcamp;
    case "boxing":
      return boxing;
    case "cardio":
      return cardio;
    case "celebrity":
      return celebrity;
    case "core":
      return core;
    case "cycling":
      return cycling;
    case "dance":
      return dance;
    case "hiit":
      return hiit;
    case "meditation":
      return meditation;
    case "mobility":
      return mobility;
    case "other":
      return other;
    case "pilates":
      return pilates;
    case "seniorFitness":
      return seniorFitness;
    case "sports":
      return sports;
    case "streching":
      return streching;
    case "toning":
      return toning;
    case "yoga":
      return yoga;

    // Icon
    case "contactSupport":
      return contactSupport;
    case "activeUp":
      return activeUp;
    case "dropdown":
      return dropdown;
    case "activeDown":
      return activeDown;
    case "down":
      return down;
    case "up":
      return up;
    case "addTemplate":
      return addTemplate;
    case "search":
      return search;
    case "high":
      return high;
    case "low":
      return low;
    case "medium":
      return medium;
    case "back":
      return back;
    //Difficulty
    case "beginner":
      return beginner;
    case "intermediate":
      return intermediate;
    case "advanced":
      return advanced;
    // Payment
    case "cardBackground":
      return cardBackground;
    case "visa":
      return visaLogo;
    case "amex":
      return americanExpress;
    case "diners":
      return diner;
    case "discover":
      return discover;
    case "jcb":
      return jcb;
    case "addCardFooterImage":
      return addCardFooterImage;
    case "unionpay":
      return union;
    case "mastercard":
      return mastercard;
    case "noStreaming":
      return noStreaming;
    case "bellIcon":
      return bellIcon;
    case "windowIcon":
      return windowIcon;
    case "dumbell":
      return dumbell;
    case "clock":
      return clock;
    case "watchHeartRate":
      return watchHeartRate;
    case "watch":
      return watch;
    case "crossIcon":
      return crossIcon;
    case "passwordInput":
      return passwordInput;
    case "emailInput":
      return emailInput;
    case "validTick":
      return validTick;
    case "logout":
      return logout;
    case "dropdownProfile":
      return dropdownProfile;
    case "dropdownSetting":
      return dropdownSetting;
    case "locationPin":
      return locationPin;
    case "calorie":
      return calorie;
    case "exercise1":
      return exercise1;
    case "exercise2":
      return exercise2;
    case "InternalBackground":
      return InternalBackground;
    case "homeNav":
      return homeNav;
    case "dumbellNav":
      return dumbellNav;
    case "manJumping":
      return manJumping;
    case "ondemandNav":
      return ondemandNav;
    case "liveUpcomingNav":
      return liveUpcomingNav;
    case "mySchedule":
      return mySchedule;
    case "carouselRightIcon":
      return carouselRightIcon;
    default:
      return ActivityDoneImg;
  }
};

const colorSelector = (heartRate) => {
  switch (true) {
    case heartRate > 0 && heartRate < 60:
      return "#507FB1";
    case heartRate >= 60 && heartRate < 70:
      return "#55BA6B";
    case heartRate >= 70 && heartRate < 80:
      return "#D6C345";
    case heartRate >= 80 && heartRate < 90:
      return "#CF832D";
    case heartRate >= 90:
      return "#F22B5D";
    default:
      // return "#ffffff";
      return "#808080";
  }
};

const textColorSelector = (heartRate) => {
  switch (true) {
    case heartRate < 0:
      return "#979797";
    case heartRate > 0 && heartRate < 60:
      return "#507FB1";
    case heartRate >= 60 && heartRate < 70:
      return "#55BA6B";
    case heartRate >= 70 && heartRate < 80:
      return "#D6C345";
    case heartRate >= 80 && heartRate < 90:
      return "#CF832D";
    case heartRate >= 90:
      return "#F22B5D";
    default:
      return "#ffffff";
  }
};

export const classSelector = (heartRate) => {
  switch (true) {
    case heartRate > 0 && heartRate < 60:
      return "veryLow";
    case heartRate >= 60 && heartRate < 70:
      return "low";
    case heartRate >= 70 && heartRate < 80:
      return "medium";
    case heartRate >= 80 && heartRate < 90:
      return "high";
    case heartRate >= 90:
      return "veryHigh";
    default:
      return "extraLow";
  }
};

const errorHandler = (value) => {
  switch (value) {
    case "alreadyEmail":
      return "There’s is already an account with this email address. Log in if you already have an account.";
    case "maxDate":
      return `An class cannot be scheduled for longer than three months`;
    case "timeError":
      return `A class that starts in less than 5 minutes from now can not be scheduled`;
    case "timeErrorEdit":
      return `An class cannot be edited 5 minutes before it starts`;
    case "invalidEmail":
      return "We can’t find an account for that email address. Please try again, or create an account";
    case "wrongPassword":
      return "The password you entered isn’t right. Please try again";
    case "matchingPassword":
      return "Password must include 2 numbers or special characters";
    case "wrongMemberShipcode":
      return "No gym or fitness studio was found with this membership code";
    case "alreadyMemberShipcode":
      return "Gym or fitness studio already linked with this account";
    default:
      return "";
  }
};
const checkError = (value) => {
  switch (value) {
    case "User already exists. Please try with another email address.":
      return "alreadyEmail";
    case "The password you entered isn’t right. Please try again.":
      return "wrongPassword";
    case "We can’t find an account for that email address. Please try again.":
      return "invalidEmail";
    case "No gym or fitness studio was found with this membership code.":
      return "wrongMemberShipcode";
    case "Gym or fitness studio already linked with this account.":
      return "alreadyMemberShipcode";
    default:
      return "";
  }
};

export const errorText = {
  alreadyEmail: "",
};

const filterSelect = (value) => {
  switch (value) {
    case "member":
      return [
        { name: "Birthday Period", value: "users.dob" },
        // { name: 'Last Attended Period', value: 'last_activity_attended_at' },
        { name: "Added On Period", value: "user_gym.approved_at" },
        // { name: 'Class Completed Range', value: 'number_of_activities_done' }
      ];
    case "coach":
      return [
        { name: "Birthday Period", value: "users.dob" },
        // { name: 'Last Attended Period', value: 'last_activity_attended_at' },
        { name: "Added On Period", value: "user_gym.approved_at" },
        // { name: 'Class Completed Range', value: 'number_of_activities_done' }
      ];
    case "date":
      return [
        { name: "Created On", value: "created_at" },
        { name: "Edited On", value: "updated_at" },
        { name: "Last Used On", value: "last_used_at" },
      ];
    case "status":
      return [
        { name: "Approved", value: "approved" },
        { name: "Reject", value: "reject" },
      ];
    case "days":
    default:
      return [
        // {name:'All time',value:'all'},
        // {name:'90 days',value:'90'},
        { name: "7 Days", value: "in_last_7_days" },
        { name: "15 Days", value: "in_last_15_days" },
        { name: "30 Days", value: "in_last_30_days" },
      ];
  }
};

// const goToLogin = () => this.props.history.push('/Login');

export {
  selectIcon,
  colorSelector,
  textColorSelector,
  errorHandler,
  checkError,
  filterSelect,
  SVG,
};
